import { SpecialMenuCard } from 'src/gql/graphql';
import { SpecialsSortKey } from './specials-sort.types';

function nullsLast(a: string | null | undefined, b: string | null | undefined): number {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  return a.localeCompare(b);
}

export function sortSpecials(
  specials: readonly SpecialMenuCard[],
  sortKey: SpecialsSortKey | undefined
): SpecialMenuCard[] {
  if (!sortKey) {
    return specials as SpecialMenuCard[];
  }

  switch (sortKey) {
    case SpecialsSortKey.topSellers:
      return [...specials].sort((a, b) => {
        const rankA = a.displayRank ?? Number.MAX_SAFE_INTEGER;
        const rankB = b.displayRank ?? Number.MAX_SAFE_INTEGER;
        if (rankA !== rankB) return rankA - rankB;
        return nullsLast(a.endStamp, b.endStamp);
      });

    case SpecialsSortKey.endingSoon:
      return [...specials].sort((a, b) => nullsLast(a.endStamp, b.endStamp));

    case SpecialsSortKey.newest:
      return [...specials].sort((a, b) => {
        if (a.startStamp == null && b.startStamp == null) return 0;
        if (a.startStamp == null) return 1;
        if (b.startStamp == null) return -1;
        return b.startStamp.localeCompare(a.startStamp);
      });

    default:
      return specials as SpecialMenuCard[];
  }
}
